import React from "react";
import { RadioButtons } from "../../../FlowConfigurationInputs";
import Table from "../../../FlowConfigurationInputs/Table/Table";
function FillEmpty({ action, setOpenVariable, automVersionId }) {
    const headers = ["Columns"];
    const options = {
        tableBody: { headers, title: "Columns" },
        radioButtons: {
            data: [{
                value: 'fillPrevious',
                label: 'Fill with previous value'
            }, {
                value: 'fillNext',
                label: 'Fill with next value(single column only)'
            }],
            defaultValue: 'fillPrevious'
        }
    };

    return (
        <div>
            <div className="form-element">
                <div className="form-element">
                    <Table
                        action={action}
                        inputName="columns"
                        automVersionId={automVersionId}
                        options={options.tableBody}
                        setOpenVariable={setOpenVariable}
                        isRequired={false}
                        isActiveDirectory={true}
                    />
                </div>
            </div>
            <div className="form-element">
                <RadioButtons action={action} inputName="fill" options={options.radioButtons} isRequired />
            </div>
        </div>
    );
}
export default FillEmpty;